import PropTypes from 'prop-types';
import React, { Component } from 'react';
import InputFormField from './input-form-field';
import { Icon } from '../components';

class PasswordFormField extends Component {
  constructor() {
    super();

    this.state = {
      showPassword: false
    };
  }

  render() {
    const {
      iconProps,
      ...otherProps
    } = this.props;

    const inputFormFieldAttributes = {
      ...otherProps,
      inputType: this.state.showPassword ? 'text' : 'password'
    };

    const iconAttributes = {
      ...iconProps,
      className: 'field-icon',
      icon: `eye-${this.state.showPassword ? 'closed' : 'open'}-thick`,
      onClick: (e) => this.setState({ showPassword: !this.state.showPassword })
    };

    return (
      <InputFormField {...inputFormFieldAttributes}>
        <Icon {...iconAttributes} />
      </InputFormField>
    );
  }
}

PasswordFormField.propTypes = {
  ...InputFormField.propTypes,
  iconProps: PropTypes.object
};

export default PasswordFormField;



// WEBPACK FOOTER //
// ./src/containers/components/password-form-field.js